export { EditorComponent } from './editor.component';
